<template>
  <div>
    <dialog-show-programs-promoter :filter="filter"
                                   :programsModalPromoter="programsModalPromoter"
                                   v-on:create-lot="$emit('create-lot')"
                                   v-on:cancel-creation-lot="$emit('cancel-creation-lot')"
    />

    <el-dialog
        :title="$t('posts.dialog.archiveMyPost')"
        :visible.sync="bienVenduModaleArchiveNOk"
        width="30%"
    >
      {{$t('posts.dialog.unPublishNOK')}}
      <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="SET_BIEN_VENDU_MODALE_ARCHIVE_NOK(false)">OK</el-button>
      </span>
    </el-dialog>

    <el-dialog
        :title="$t('posts.dialog.archiveMyPost')"
        :visible.sync="bienVenduModaleArchiveOk"
        width="30%"
    >
      {{$t('posts.dialog.archiveConfirm')}}
      <span slot="footer" class="dialog-footer">
                    <el-button  @click="SET_BIEN_VENDU_MODALE_ARCHIVE_OK(false)">{{$t('posts.dialog.cancel')}}</el-button>
                    <el-button type="primary" @click="$emit('archiver-bv')">OK</el-button>
                </span>
    </el-dialog>

    <el-dialog
        :title="$t('posts.dialog.selectModelTitle')"
        :visible.sync="modalShowModels"
        width="30%"
    >
          <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="SET_MODAL_SHOW_MODELS(false)">OK</el-button>
          </span>
    </el-dialog>

    <el-dialog
        :title="$t('posts.dialog.selectModelTitleCmiste')"
        :visible.sync="modalShowModelsCmiste"
        width="30%"
        v-loading="loadingCMIcreatePost"
        :element-loading-text="$t('portals.list.chargementDonnees')"
        @close="SET_MODAL_SHOW_MODELS_CMISTE(false)"
    >
      <el-form :rules="rulesCMI">
        <el-form-item :label="$t('posts.dialog.propertyType') + ' *'" prop="selectTypeObjetModele">
          <el-radio-group
              v-model="selectTypeObjetModele"
              @change="fetchDataModelsCmiste(selectTypeObjetModele)">
            <el-radio label="1310" value="1310">{{ $t("posts.edit.typeLand") }}</el-radio>
            <el-radio label="5200" value="5200">{{ $t("posts.edit.typeLandHouse") }}</el-radio>
          </el-radio-group>

        </el-form-item>
        <el-row :gutter="25">
          <el-col :span="tailleSelectPopup">
            <el-form-item v-if="(selectTerrainCmisteModele == true) && listeTerrains" :label="labelModeleTerrain" prop="currentLandId">
              <el-select v-model="currentLandId"
                         :placeholder="$t('posts.dialog.selectListTerrain') + ' *'"
                         @change="checkModelCmisteButton({ landId: currentLandId, modelId: currentModelId, programId: currentProgramId })"
                         v-if="listeTerrains !== null"
                         filterable
                         clearable>
                <el-option
                    v-for="terrain in listeTerrains.list"
                    :key="terrain.id"
                    :label="terrain.reference + ' - ' + terrain.titre"
                    :value="terrain.id"
                ></el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="tailleSelectPopup">
            <el-form-item v-if="selectModeleCmiste == true" :label="$t('posts.dialog.selectModel')+ ' *'"  prop="currentModelId">
              <el-select
                  v-model="currentModelId"
                  @change="checkModelCmisteButton({ landId: currentLandId, modelId: currentModelId, programId: currentProgramId })"
                  :placeholder="$t('posts.dialog.selectListModel')"
                  v-if="listeModeles !== null"
                  filterable
                  clearable>
                <el-option
                    class="selectListeModeles"
                    v-for="modele in listeModeles.list"
                    :key="modele.id"
                    :label="modele.reference + ' - ' + modele.titre"
                    :value="modele.id"
                >
                  <div class="block-image-principale">
                    <div class="image-principale">
                      <div class="container-image-principale" v-if="modele.photoPrincipale"><img  :src="modele.photoPrincipale.url_miniature"></div>
                      <div class="container-no-image" v-else><i class="el-icon-camera"></i></div>
                    </div>
                    <div class="modele-text"><span>{{modele.titre}}</span></div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row  v-if="selectModeleCmiste == true && listeProgramModeles && (listeProgramModeles.list.length > 0)">
          <el-form-item :label="$t('posts.dialog.selectModelProgram') + ' *'"  prop="currentProgramId">
            <el-select
                v-model="currentProgramId"
                @change="checkModelCmisteButton({ landId: currentLandId, modelId: currentModelId, programId: currentProgramId })"
                :placeholder="$t('posts.dialog.selectModelProgram')"
                v-if="listeProgramModeles !== null"
                filterable
                clearable>
              <el-option
                  v-for="modeleProgram in listeProgramModeles.list"
                  :key="modeleProgram.id"
                  :label="modeleProgram.reference + ' - ' + modeleProgram.titre"
                  :value="modeleProgram.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-form-item :label="$t('posts.dialog.selectReference')">
          <el-input v-model="referenceDuplication"
                    @input="checkModelCmisteButton"
                    :placeholder="$t('posts.dialog.selectReferencePlaceholder')"
                    :label="$t('posts.dialog.selectReference')"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="SET_MODAL_SHOW_MODELS_CMISTE(false)">{{ $t("posts.dialog.cancel") }}</el-button>
                    <el-button type="primary" :disabled="modalCmisteModelDisabled" @click="$emit('fusionner', { landId: currentLandId, modelId: currentModelId, programId: currentProgramId, reference: referenceDuplication, redirect: true })" v-if="selectTerrainCmisteModele === true && selectModeleCmiste === true">{{ $t("posts.dialog.confirm") }}</el-button>
                    <el-button type="primary" :disabled="modalCmisteModelDisabled" @click="$emit('dupliquer', { id: currentLandId, reference: referenceDuplication, redirect: true })" v-else>{{ $t("posts.dialog.confirm") }}</el-button>
      </span>
    </el-dialog>

    <dialog-delete-post v-on:delete-post="$emit('delete-post')" v-on:close-modal-delete="$emit('close-modal-delete')" v-on:sold-post="$emit('sold-post')"></dialog-delete-post>

    <dialog-delete-multiple-posts
        :modalConfirmedDeleteList="modalConfirmedDeleteList"
        :titreModalConfirmedDeleteList="titreModalConfirmedDeleteList"
        :selected="selected"
        v-on:delete-selected="$emit('delete-selected')"
        v-on:delete-all-selected="$emit('delete-all-selected')"
    />

    <dialog-change-contact-multiple-posts
        :selected="selected"
        :modalConfirmedChangeContactList="modalConfirmedChangeContactList"
        v-on:close-change-contacts="$emit('close-change-contacts')"
        v-on:unselect-call="$emit('unselect-call')"
    />

    <el-dialog
        :visible.sync="modalCreationLot"
        width="30%"
        @close="SET_MODAL_CREATION_LOT(false)"
    >
      <span class="text-justify">{{ $t("posts.dialog.textCreateLot") }}</span>
      <br>
      <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="SET_MODAL_CREATION_LOT(false)">OK</el-button>
                </span>
    </el-dialog>

    <dialog-use-model
        v-on:close-modal-use-model="$emit('close-modal-use-model')"
        v-on:dupliquer-annonce="$emit('dupliquer-annonce', $event)">
    </dialog-use-model>

    <el-dialog
        :title="$t('posts.dialog.duplicateTitle')"
        :visible.sync="modalDuplicate"
        width="30%"
        @close="SET_MODAL_DUPLICATE(false)"
    >
      <span>{{ $t("posts.dialog.duplicateText") }}</span>
      <br>
      <br>
      <el-input v-model="referenceDuplication"
                :placeholder="$t('posts.dialog.duplicatePlaceholder')"
                :label="$t('posts.dialog.duplicatePlaceholder')"></el-input>
      <span slot="footer" class="dialog-footer">
                <el-button @click="SET_MODAL_DUPLICATE(false)">{{ $t("posts.dialog.cancel") }}</el-button>
                <el-button type="primary" @click="$emit('dupliquer-annonce', {'reference' : referenceDuplication, 'redirect': true })">{{ $t("posts.dialog.confirm") }}</el-button>
            </span>
    </el-dialog>

    <dialog-show-onboarding-b-v v-if="isSoldProductsOption" v-on:stop-popup-bv="$emit('stop-popup-bv')"></dialog-show-onboarding-b-v>

  </div>
</template>

<script>

import DialogShowProgramsPromoter from './DialogShowProgramsPromoter'
import DialogDeletePost from './DialogDeletePost'
import DialogDeleteMultiplePosts from './DialogDeleteMultiplePosts'
import DialogChangeContactMultiplePosts from './DialogChangeContactMultiplePosts'
import DialogUseModel from './DialogUseModel'
import DialogShowOnboardingBV from './DialogShowOnboardingBV'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { getPosts } from '@/services/posts'

export default {
  name: 'DialogsPostsListImmo',
  components: {
    DialogShowProgramsPromoter,
    DialogDeletePost,
    DialogDeleteMultiplePosts,
    DialogChangeContactMultiplePosts,
    DialogUseModel,
    DialogShowOnboardingBV
  },
  props: [
    'programsModalPromoter',
    'modalShowModels',
    'modalDelete',
    'selected',
    'titreModalConfirmedDeleteList',
    'modalCreationLot'
  ],
  computed: {
    ...mapGetters('postsListImmo', [
      'modalConfirmedChangeContactList',
      'loadingCMIcreatePost',
      'modalConfirmedDeleteList',
      'bienVenduModaleArchiveNOk',
      'bienVenduModaleArchiveOk',
      'currentLandId',
      'currentModelId',
      'currentProgramId',
      'filter'
    ]),
    ...mapGetters('dialogsPostsListImmo', [
      'modalConfirmedDeleteList',
      'referenceDuplication',
      'modalDuplicate'
    ]),
    ...mapState('postsListImmo', ['selection']),
    ...mapState('dialogsPostsListImmo', [
      'modalShowModelsCmiste',
      'selectTypeObjetModele'
    ]),
    isSoldProductsOption () {
      return this.$store.getters.isSoldProductsOption
    },
    selectTypeObjetModele: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/selectTypeObjetModele']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_SELECT_TYPE_OBJET_MODELE', value)
      }
    },
    referenceDuplication: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/referenceDuplication']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_REFERENCE_DUPLICATION', value)
      }
    },
    currentModelId: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/currentModelId']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_CURRENT_MODEL_ID', value)
      }
    },
    currentLandId: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/currentLandId']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_CURRENT_LAND_ID', value)
      }
    },
    loadingCMIcreatePost: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/loadingCMIcreatePost']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_LOADING_CMI_CREATE_POST', value)
      }
    },
    currentProgramId: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/currentProgramId']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_CURRENT_PROGRAM_ID', value)
      }
    },
    modalCmisteModelDisabled: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/modalCmisteModelDisabled']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_MODAL_CMISTE_MODEL_DISABLED', value)
      }
    },
    modalShowModelsCmiste: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/modalShowModelsCmiste']
      },
      set (value) {
        this.$store.commit('dialogsPostsListImmo/SET_MODAL_SHOW_MODELS_CMISTE', value)
      }
    }
  },
  data () {
    return {
      rulesCMI: {
        selectTypeObjetModele: [{
          required: true,
          message: this.$t('validator.selectTypeObjetModeleRequired'),
          trigger: 'blur'
        }],
        currentModelId: [{ required: true, message: this.$t('validator.currentModelIdRequired'), trigger: 'blur' }],
        currentProgramId: [{ required: true, message: this.$t('validator.currentProgramIdRequired'), trigger: 'blur' }],
        currentLandId: [{ required: true, message: this.$t('validator.currentProgramIdRequired'), trigger: 'blur' }]
      },
      tailleSelectPopup: 24,
      inputRefDuplication: null,
      selectTerrainCmisteModele: false,
      labelModeleTerrain: null,
      selectModeleCmiste: null,
      listeProgramModeles: null,
      listeTerrains: null,
      listeModeles: null
    }
  },
  beforeMount () {
    this.SET_REFERENCE_DUPLICATION(null)
    this.SET_SELECT_TYPE_OBJET_MODELE(null)
    this.SET_CURRENT_LAND_ID(null)
    this.SET_CURRENT_MODEL_ID(null)
    this.SET_CURRENT_PROGRAM_ID(null)
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'SET_MODAL_SHOW_MODELS',
      'SET_MODAL_CREATION_LOT',
      'SET_SELECT_TYPE_OBJET_MODELE'
    ]),
    ...mapMutations('dialogsPostsListImmo', [
      'SET_MODAL_CONFIRMED_DELETE_LIST',
      'SET_BIEN_VENDU_MODALE_ARCHIVE_NOK',
      'SET_BIEN_VENDU_MODALE_ARCHIVE_OK',
      'SET_REFERENCE_DUPLICATION',
      'SET_CURRENT_LAND_ID',
      'SET_CURRENT_PROGRAM_ID',
      'SET_CURRENT_MODEL_ID',
      'SET_MODAL_SHOW_MODELS_CMISTE',
      'SET_MODAL_DUPLICATE'
    ]),
    async fetchDataModelsCmiste (payload) {
      this.selectTypeObjetModele = payload
      this.loadingCMIcreatePost = true
      if (this.selectTypeObjetModele == 1310) {
        this.labelModeleTerrain = this.$t('posts.dialog.selectTerrain') + ' *'
        this.selectTerrainCmisteModele = true
        this.rulesCMI.currentLandId[0].required = true
        this.selectModeleCmiste = false
        this.listeTerrains = await getPosts({
          typeObjets: 1310,
          annoncesModeles: true,
          limit: 200,
          fields: 'id,reference,titre'
        })
        this.tailleSelectPopup = 24
      }
      if (this.selectTypeObjetModele == 5200) {
        this.labelModeleTerrain = this.$t('posts.dialog.selectTerrain')
        this.selectModeleCmiste = true
        this.rulesCMI.currentLandId[0].required = false
        this.selectTerrainCmisteModele = true
        this.listeTerrains = await getPosts({
          typeObjets: 1310,
          annoncesModeles: true,
          limit: 200,
          fields: 'id,reference,titre'
        })
        this.listeModeles = await getPosts({
          typeObjets: 1200,
          annoncesModeles: true,
          limit: 200,
          fields: 'id,reference,titre'
        })
        this.listeProgramModeles = await getPosts({
          typeObjets: 5200,
          annoncesModeles: true,
          limit: 200,
          fields: 'id,reference,titre'
        })
        this.tailleSelectPopup = 12
      }
      this.loadingCMIcreatePost = false
    },
    async fetchTerrains () {
      const terrainsFilters = {
        itemsPerPage: 150
      }
      const result = await getPosts(terrainsFilters)
      if (result.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.setLoadingStatus(false)
        return false
      }
    },
    async getModels () {
      const result = await getPosts(this.filter)
      if (result.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.setLoadingStatus(false)
        return false
      }
    },
    checkModelCmisteButton (payload) {
      console.log(payload)
      if (payload.landId) {
        this.currentLandId = payload.landId
      }
      if (payload.modelId) {
        this.currentModelId = payload.modelId
      }
      if (payload.programId) {
        this.currentProgramId = payload.programId
      }

      // Cas 1 Programmes Avec programmes terrain + maison
      // Cas 2 Terrain + maison avec Programme T+M
      // Cas 4 Terrain avec terrain
      if (this.selectTypeObjetModele === '5200') {
        if (
          this.currentProgramId &&
            (this.currentLandId || this.currentModelId)
        ) {
          this.modalCmisteModelDisabled = true
        } else if (this.currentProgramId) {
          this.modalCmisteModelDisabled = false
        } else if (!this.currentLandId && this.currentModelId) {
          this.modalCmisteModelDisabled = false
        } else if (this.currentLandId && this.currentModelId) {
          this.modalCmisteModelDisabled = false
        } else {
          this.modalCmisteModelDisabled = true
        }
      } else if (this.currentLandId && this.selectTypeObjetModele === '1310') {
        this.modalCmisteModelDisabled = false
      } else {
        this.modalCmisteModelDisabled = true
      }
    }
  }
}
</script>

<style scoped>
.selectListeModeles {
  height: 115px;
  margin-bottom: 23px;
  display: flex;
  align-items: center;
}
.block-image-principale{
  display: flex;
  align-items: center;
}

.image-principale {
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.image-principale :not(.container-image-principale){
  height: 115px;
  width: 150px;
  background-color: #FFEFDF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-image-principale img {
  height: 100px;
  border-radius: 5px;
}

.container-no-image i.el-icon-camera {
  font-size: 54px;
}

</style>
